class Config {
  minStart: any;
  maxEnd: any;

  constructor() {
    this.minStart = "08:30:00";
    this.maxEnd = "17:30:00";
  }
}

export default Config;
